import React, { useContext, useState } from 'react';
import { SetupDataPageTemplate } from '../../../components/setup-pages/SetupDataPageTemplate';
import { resetUserSettings } from '../../../services/userService';
import { setupData } from '../../../configs/routes';
import { Form } from "react-jsonschema-form-validation";
import { pathRoot, getOptionsElements } from '../AsbestosHistory';
import { DiseaseGroupContext } from '../../../contexts/diseaseGroupContext';

export function Page1({ asbestosHistory }) {

	const schema = {
		type: "object"
	};

	const optionsData = [
		{
			label: "Yes, through my own work",
			value: 0
		}, {
			label: "Yes, through another person's work",
			value: 1
		}, {
			label: "Yes, my home had asbestos (e.g. whilst doing DIY)",
			value: 2
		}, {
			label: "Yes, by living near an asbestos factory",
			value: 3
		}, {
			label: "No/Don't know",
			value: 4
		}
	];

	const [asbestosExposure, setAsbestosExposure] = useState(asbestosHistory.asbestosExposure);

	const hideNext = () => {
		return asbestosExposure === null;
	};

	const updateUserSettings = () => {
		asbestosHistory.asbestosExposure = asbestosExposure;
	};

	const headerDetails = {
		title: "Asbestos History",
		currentPage: 1,
		pageCount: 4
	};

	const {theme} = useContext(DiseaseGroupContext);

	return (<>
		<SetupDataPageTemplate headerDetails={headerDetails} backTo={setupData} nextTo={`${pathRoot}/2`} onClickBack={resetUserSettings} onClickNext={updateUserSettings} hideNext={hideNext()}>
			
			<Form schema={schema}>
				<p className={"text-lg sm:text-xl font-bold mb-6"}>From your memory were you ever exposed to Asbestos?</p>
				
				<div>
					{getOptionsElements(optionsData, "asbestosExposure", asbestosExposure, setAsbestosExposure, theme)}
				</div>
			</Form>
			
		</SetupDataPageTemplate>
	</>);
}
